<template>
  <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_48352_215799)">
      <path d="M44.0913 61.8232L56.9016 44.7734M75.2777 67.7401V39.1154C75.2777 36.3916 73.0492 34.163 70.3253 34.163H50.7139C49.2777 34.163 47.8911 33.5192 46.9501 32.4297L44.7711 29.8544C43.8301 28.7649 42.4434 28.1211 41.0072 28.1211H30.7063C27.9825 28.1211 25.7539 30.3497 25.7539 33.0735V67.7401C25.7539 70.464 27.9825 72.6925 30.7063 72.6925H70.3253C73.0492 72.6925 75.2777 70.464 75.2777 67.7401Z" stroke="currentColor" stroke-width="5.57143" stroke-linecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_48352_215799">
        <rect x="0.515625" y="0.40625" width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
